import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { EmpresasService } from '../../services/empresas/empresas.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../models/messages';
import Swal from "sweetalert2";
import { LoginService } from 'app/services/login/login.service';


@Component({
  selector: 'app-contactos',
  templateUrl: './contactos.component.html',
  styleUrls: ['./contactos.component.scss'],
  providers:[MessagesTitles, MessagesStatus]
})
export class ContactosComponent implements OnInit {
  
  adjuntarPDF : boolean;
  abrirAgregarProveedor : boolean;
  abrirAgregarAdquirente : boolean;

  abrirAgregarContacto : boolean = false;

  razSocial : string;
  rucEmpresa: string;
  ruta :string;
  idContactos: string;
  idEmpresa : string;
  Fcontacto : any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [10,20,30,50,100,200];
  docNegociables:any = [];
  loading:boolean=false;
  displayedColumns: string[] = 
            ['checked','Des_Estado','Nombre_de_Contacto','Correo','NroMovil_Laboral','NroFijo_Laboral','Anexo','Des_Tipo_de_Contacto','Rol_Del_Contacto_Dsc','Des_Condicion'];
  dataSource = new MatTableDataSource( this.docNegociables) ;

  constructor(private activateRoute :ActivatedRoute,
    private empresasService:EmpresasService ,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus,
    private router :Router,
    private loginService:LoginService, ) {
    
    this.adjuntarPDF = false;
    this.activateRoute.params.subscribe( params => {
      this.rucEmpresa = this.empresasService.ruc;
      this.idEmpresa = params['id']; 
      
    })
   }

  ngOnInit() {
    this.obtenerContactos(this.idEmpresa);
    this.abrirAgregarProveedor = false;
    this.abrirAgregarAdquirente = false;
    let rutas = this.router.url.split("/",3);
    this.ruta = rutas[2];
    this.rucEmpresa=sessionStorage.getItem('rucEmpresa');
    const elem=document.getElementById('button-oculto');
    elem.style.display='none';
  }
  Regresar(id:any=this.rucEmpresa){
    console.log(id)
    if (this.ruta == 'proveedor') {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/proveedor/listado',id]);
    } else if (this.ruta == 'adquirente') {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/adquirente/listado',id]);
    }else {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/inversor/listado/',id]);
    }
    }
  obtenerContactos(id:string){
    this.loading = true;
    
    this.empresasService.obtenerContactosEmpresa(id).subscribe(
      res => {
        this.docNegociables = res;
        this.razSocial = sessionStorage.getItem('razSocial');
        this.dataSource = new MatTableDataSource(this.docNegociables);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      },(err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
        } else {
            this.msgStatus.getMessage(err.status);            
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Contacto no encontrado. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      }
    );
  }

  eliminarContacto(idContacto : number){

    Swal.fire({
      title: '¿Está seguro de eliminar el contacto?',
      text: "Esta acción no se puede deshacer.",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete.',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.loading=true;
        this.empresasService.eliminarContacto(idContacto)
        .subscribe(res => {           
          Swal.fire({
            title: 'Contact delete',
            text: res["message"],
            type: 'success',
            heightAuto: false
          }).then(resp => {
            this.loading=false;
            if (resp.value == true) {
              this.obtenerContactos(this.idEmpresa);
            }
          });
        },(err: HttpErrorResponse)=> {
          if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);            
        }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "Contacto no eliminado. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.loading = false;
      }
    })

  }

  CerrarPopUpProveedor(click:boolean){
   
      this.abrirAgregarProveedor = false;
      this.obtenerContactos(this.idEmpresa);
     
   }

  CerrarPopUpAdquirente(click:boolean){
   
    this.abrirAgregarAdquirente = false;
    this.obtenerContactos(this.idEmpresa);
   
  }
  
  CerrarVentaAdjunto(){
   
  this.adjuntarPDF = false;
  this.obtenerContactos(this.idEmpresa);

  }  
  
  abrirAdjuntarPDF(fila : string , tipoEmision?: string){
   
    if(fila['Des_Estado']=='DE BAJA'){
      Swal.fire({
        title: "Error",
        text: "No se puede agregar anexos a usuarios en estado de 'Baja'",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    } 
    this.adjuntarPDF = true;
    this.Fcontacto = fila;
  }

  editarContacto(idContacto:string){
    this.idContactos = idContacto;
    this.abrirAgregarContacto = true;
  }

  nuevoContacto(){
    this.idContactos = "";
    this.abrirAgregarContacto = true;
  }

  verContacto(element : any){
    element.idEmpresa = this.idEmpresa;
    element.rucEmpresa = this.rucEmpresa
    this.empresasService.datos = element;
    this.router.navigate(['/empresas/inversor/verificacion']);
  }

  CerrarPopUpContacto(){
   
    this.abrirAgregarContacto = false;
    this.obtenerContactos(this.idEmpresa);
   
  }

}
